import services from 'services/services';
import * as types from '../../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH MAIN AVAILABILITY - TABLE DATA ********************
export const fetchMainAvailability = (options, itemId) => async (
	dispatch,
	getState
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_MAIN_AVAILABILITY_TABLE_LOADING,
			payload: true
		});

		const {
			main: {
				availability: {
					table: {
						columns,
						options: { startIndex: startTableIndex, page }
					}
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		const url = `/timetables/availability/listByProduct/packet/${itemId}?${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// // Dispatch an action with data
		dispatch({
			type: types.FETCH_MAIN_AVAILABILITY_TABLE_SUCCESS,
			payload: {
				...data,
				pages,
				page: options.page,
				startIndex
			}
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_MAIN_AVAILABILITY_TABLE_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE MAIN AVAILABILITY ********************
export const deleteMainAvailability = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_MAIN_AVAILABILITY_LOADING,
			payload: true
		});

		await services.delete(`/timetables/availability/${id}`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_MAIN_AVAILABILITY_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_MAIN_AVAILABILITY_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
